import i18n from '../services/i18n';

export const getActiveLanguage = () => {
  const [activeLanguage] = String(i18n.language).split('-');
  return activeLanguage;
};

export const getActiveLanguageData = (data = {}) => {
  const activeLanguage = getActiveLanguage();
  return data[activeLanguage];
};
